import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state() {
    return {
      duplicateList: [],
      // company: {},
      // companyActivity: [],
      // companyLocations: [],
      // metadata: {},
      // editionMode: false
    }
  },
  getters,
  actions,
  mutations
}
